{
  "R": [0, 0, 128, 255, 255],
  "G": [0, 128, 0, 128, 255],
  "B": [0, 125, 255, 0, 255],
  "A": [0, 32, 64, 96, 128],
  "I": [0, 63, 128, 192, 255]
}
